import Cue from "../cue/Cue";

export function cloneCue(cue: Cue): Cue {
  return new Cue(cue.startTimeStamp, cue.duration);
}
